// Registry for the `screen:<id>` figures in docs/concepts/revenue-cycle.md.
// pages/ConceptPage.js resolves `![caption](screen:ledger)` to the component
// here and renders it inside the same <figure>.
import TeaserSheet from './TeaserSheet';
import ClaimJourney from './ClaimJourney';
import Initiatives from './Initiatives';
import Ledger from './Ledger';
import { DEMO_SHOTS } from './DemoShots';

export const RCM_SCREENS = {
  teaser: TeaserSheet,
  'claim-journey': ClaimJourney,
  initiatives: Initiatives,
  ledger: Ledger,
  ...DEMO_SHOTS, // demo-blueprint · demo-pipeline · demo-review (visitor detours)
};
